"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadNetCombobulator = void 0;
const NetCombobulator_1 = require("../../NetCombobulation/NetCombobulator");
const KicadNetNamingStrategy_1 = require("./KicadNetNamingStrategy");
class KicadNetCombobulator extends NetCombobulator_1.NetCombobulator {
    constructor(netRefCtx, opts = {}, namingStrategy = new KicadNetNamingStrategy_1.KicadNetNamingStrategy()) {
        super(netRefCtx, namingStrategy, undefined, opts);
    }
}
exports.KicadNetCombobulator = KicadNetCombobulator;
//# sourceMappingURL=KicadNetCombobulator.js.map